






































































import { tns } from "tiny-slider/src/tiny-slider";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class UspsSlider extends Vue {
    @Prop({ required: true }) usps!: { title: string };

    $refs!: Vue["$refs"] & {
        slider: HTMLElement;
        navContainer: HTMLElement;
    };

    slider: any = null;

    private mounted() {
        this.initSlider();
    }

    private initSlider() {
        this.$nextTick(() => {
            // @ts-nocheck
            this.slider = tns({
                container: this.$refs.slider,
                items: 1.1,
                gutter: 16,
                preventScrollOnTouch: "force",
                mouseDrag: true,
                loop: false,
                controls: true,
                controlsContainer: this.$refs.navContainer,
                swipeAngle: false,
                nav: false,
                responsive: {
                    1024: {
                        items: 3,
                        gutter: 32
                    }
                }
            });
        });
    }
}
